"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _defineProperty2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
var _vuex = require("vuex");
var _yunying = require("@/api/yunying");
var _h5ConfigManage = _interopRequireDefault(require("./components/h5-config-manage"));
var _api = require("./api");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var TEMPLATE_ID = 'page_config_template_id';
var _default = exports.default = {
  components: {
    Manage: _h5ConfigManage.default
  },
  data: function data() {
    return {
      manageType: '',
      // 编辑类型
      searchInput: '',
      // 搜索输入
      chooseData: {},
      // 当前修改项的表单参数 （用于填充 Manage）
      loading: true,
      commonTableData: [],
      // 公共配置页面列表
      tableData: [],
      // 配置页面列表
      tablePage: {
        per_page: 100,
        current: 1,
        total_page: 1,
        total_num: 1
      },
      templateId: 0,
      // 模板id
      templateList: [],
      //接口下发
      teacherGroupList: [],
      // 老师分组列表
      wxGroupList: [],
      // 微信分组列表
      configMap: new Map(),
      // 配置map
      colorList: ['blue', 'green', 'yellow', 'red']
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapState)({
    reg_channels: function reg_channels(state) {
      return state.common.reg_channels;
    }
  })), {}, {
    isCommonTemplate: function isCommonTemplate() {
      var _this = this;
      var isCommon = this.templateList.some(function (v) {
        return v.template_id === _this.templateId && v.is_common === 1;
      });
      return isCommon;
    }
  }),
  mounted: function mounted() {
    var params = {
      page: 1,
      per_page: 500
    };
    this.initTableData();
    this.getRegChannels({
      params: params
    }); // 获取渠道组
    this.getWxGroupList(); //获取微信分组
    this.getTeacherGroupList(); // 获取老师分组
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)({
    getRegChannels: 'common/getRegChannels'
  })), {}, {
    initTableData: function initTableData() {
      var _this2 = this;
      (0, _api.getTemplateList)().then(function (_ref) {
        var code = _ref.code,
          data = _ref.data;
        if (code === 200 && data) {
          _this2.templateList = data;
          var cacheTemplateId = sessionStorage.getItem(TEMPLATE_ID);
          var templateId = cacheTemplateId ? Number(cacheTemplateId) : -1;
          _this2.templateId = templateId > -1 ? templateId : data[0].template_id; // 默认第一个
          // 请求列表
          _this2.getList();
        }
      });
    },
    // 获取列表
    getList: function getList() {
      var _this3 = this;
      this.loading = true;
      if (this.isCommonTemplate) {
        // 获取公共模板数据
        (0, _api.getCommonTemplateData)(this.templateId).then(function (_ref2) {
          var data = _ref2.data,
            code = _ref2.code;
          if (code === 200) {
            _this3.commonTableData = data;
          }
        }).finally(function () {
          _this3.loading = false;
        });
      } else {
        // 获取独立模板数据
        var params = {
          template_id: this.templateId,
          module: 'fans',
          name: this.searchInput,
          page: this.tablePage.current,
          per_page: this.tablePage.per_page
        };
        (0, _api.getTemplateData)(params).then(function (_ref3) {
          var data = _ref3.data,
            code = _ref3.code;
          if (code === 200) {
            var list = data.list,
              current_page = data.current_page,
              per_page = data.per_page,
              total_num = data.total_num,
              total_page = data.total_page;
            _this3.tablePage = {
              per_page: per_page,
              current: current_page,
              total_page: total_page,
              total_num: total_num
            };
            _this3.tableData = list;
          }
        }).finally(function () {
          _this3.loading = false;
        });
      }
    },
    // 新增组件完成更新视图
    upDateList: function upDateList() {
      this.getList();
    },
    // 分页数据请求
    handleCurrentChange: function handleCurrentChange(page) {
      this.tablePage.current = page;
      this.getList();
    },
    // 搜索
    onSearch: function onSearch() {
      this.getList();
    },
    // 新增
    onAdd: function onAdd() {
      this.manageType = 'add';
      this.chooseData = {
        title: '',
        flag: '',
        app_id: '',
        production_url: '',
        sandbox_url: '',
        template_id: this.templateId
      };
      this.$refs.managePop.dialogVisible = true;
    },
    // 修改
    onModify: function onModify(val) {
      this.manageType = 'modify';
      this.chooseData = {
        title: val.title,
        flag: val.flag,
        app_id: val.app_id,
        production_url: val.production_url,
        sandbox_url: val.sandbox_url,
        id: val.page_id,
        template_id: val.template_id
      };
      this.$refs.managePop.dialogVisible = true;
    },
    // 资源配置
    onConfig: function onConfig(val, type) {
      var flag = val.flag,
        page_id = val.page_id;
      var name = this.$route.name;
      this.$router.push({
        name: 'config',
        query: {
          flag: flag,
          type: type,
          page_id: page_id,
          modules: name,
          template_id: this.templateId
        }
      });
    },
    // 删除
    onDelete: function onDelete(val) {
      var _this4 = this;
      var title = val.title,
        page_id = val.page_id,
        app_id = val.app_id;
      this.$confirm("\u5373\u5C06\u5220\u9664\u3010".concat(app_id, " ").concat(title, "\u3011, \u662F\u5426\u7EE7\u7EED?"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _yunying.deletePage)({
          page_id: page_id
        }).then(function (_ref4) {
          var data = _ref4.data;
          _this4.$message({
            message: '删除成功',
            type: 'success'
          });
          // 更新数据
          _this4.getList();
        });
      });
    },
    // 查看测算链接
    checkLink: function checkLink(link) {
      window.open(link, '_blank');
    },
    // 复制
    onCopy: function onCopy(e) {
      this.$message({
        type: 'success',
        message: '复制成功!',
        duration: 1000
      });
    },
    onError: function onError(e) {
      this.$message.error('复制失败!');
    },
    onTemplateIdChange: function onTemplateIdChange() {
      // 模板变更重置
      this.tablePage = {
        per_page: 100,
        current: 1,
        total_page: 1,
        total_num: 1
      };
      this.searchInput = '';
      this.getList();
      sessionStorage.setItem(TEMPLATE_ID, this.templateId);
    },
    onExpandChange: function onExpandChange(row) {
      if (this.configMap.has(row.page_id)) {
        return;
      }
      this.getConfigData(row.page_id);
    },
    /**
     * 获取配置
     * @param pageId
     */
    getConfigData: function () {
      var _getConfigData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(pageId) {
        var _this5 = this;
        var res, _res, code, data, configList, list, newMap;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, _yunying.getPageConfig)({
                page_id: pageId
              });
            case 3:
              res = _context.sent;
              _context.next = 9;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);
            case 9:
              if (res) {
                _res = res, code = _res.code, data = _res.data;
                if (code === 200 && data) {
                  configList = data.page_component[0] ? data.page_component[0].component : [];
                  list = configList.map(function (item, index) {
                    var config_data = item.config_data,
                      channel_item = item.channel_item,
                      reg_channel_group = item.reg_channel_group;
                    var _config_data$ = config_data[0],
                      extend = _config_data$.extend,
                      template_id = _config_data$.template_id,
                      wechat_group_id = _config_data$.wechat_group_id;
                    var newData = {
                      title: "\u914D\u7F6E".concat(index + 1),
                      extend: extend,
                      channel_item: channel_item,
                      teacher_group: _this5.getGroupById(template_id, _this5.teacherGroupList),
                      wx_group: _this5.getGroupById(wechat_group_id, _this5.wxGroupList),
                      channel_group: _this5.getChannelGroupByIds(reg_channel_group)
                    };
                    return newData;
                  });
                  newMap = new Map(this.configMap);
                  newMap.set(pageId, list);
                  this.configMap = newMap;
                }
              }
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 6]]);
      }));
      function getConfigData(_x) {
        return _getConfigData.apply(this, arguments);
      }
      return getConfigData;
    }(),
    // 获取老师分组/微信分组
    getGroupById: function getGroupById(id, list) {
      var item = list.find(function (item) {
        return item.id === id;
      }) || {};
      return item.name || '';
    },
    // 获取渠道组
    getChannelGroupByIds: function getChannelGroupByIds(ids) {
      var _this6 = this;
      var list = [];
      var _loop = function _loop(i) {
        var item = _this6.reg_channels.find(function (item) {
          return item.id === ids[i];
        });
        if (item) {
          list.push(item.name);
        }
      };
      for (var i = 0; i < ids.length; i++) {
        _loop(i);
      }
      return list;
    },
    // 获取微信分组列表
    getWxGroupList: function getWxGroupList() {
      var _this7 = this;
      var params = {
        page: 1,
        per_page: 1000
      };
      (0, _yunying.getWxGroup)(params).then(function (_ref5) {
        var data = _ref5.data,
          code = _ref5.code;
        if (code === 200 && data) {
          _this7.wxGroupList = data.list;
        }
      });
    },
    // 获取老师分组列表
    getTeacherGroupList: function getTeacherGroupList() {
      var _this8 = this;
      var params = {
        page: 1,
        per_page: 100
      };
      (0, _yunying.getTeacher)(params).then(function (_ref6) {
        var data = _ref6.data,
          code = _ref6.code;
        if (code === 200 && data) {
          var teacherGroup = data.list.map(function (v) {
            var content = JSON.parse(v.content);
            return {
              content: content,
              name: "".concat(v.name, "-").concat(content.name),
              id: v.id
            };
          });
          _this8.teacherGroupList = teacherGroup;
        }
      });
    },
    getHeaderStyle: function getHeaderStyle(level) {
      var backgroundColor = '#ffffff';
      if (level === 2) {
        backgroundColor = '#F2F6FC';
      } else if (level == 3) {
        backgroundColor = '#f0f9eb';
      }
      return {
        backgroundColor: backgroundColor,
        color: '#666666'
      };
    }
  })
};